import type { ComponentType, SVGProps } from "react";
import Link from "next/link";
import * as gtm from "../../lib/gtm";
import { CONTAINER_CLASS, FOCUS_RING_ON_DARK_CLASS, SOCIAL_LINKS } from "./homepageLinks";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokIcon,
  YouTubeIcon,
} from "./icons";

const SOCIAL_ICONS: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  Instagram: InstagramIcon,
  TikTok: TikTokIcon,
  Facebook: FacebookIcon,
  YouTube: YouTubeIcon,
  LinkedIn: LinkedInIcon,
};

/** Consistent, minimal social-icons-only footer across shopper pages. */
export default function HomeFooter() {
  return (
    <footer className="bg-home-forest text-white" role="contentinfo" data-testid="socials-only-footer">
      <div className={`${CONTAINER_CLASS} py-4 sm:py-5`}>
        <ul className="flex flex-wrap items-center justify-center gap-3" aria-label="Youdle on social media">
          {SOCIAL_LINKS.map((social) => {
            const Icon = SOCIAL_ICONS[social.name];
            return (
              <li key={social.name}>
                <Link
                  href={social.href}
                  rel="noopener noreferrer"
                  target="_blank"
                  className={`inline-flex h-11 w-11 items-center justify-center rounded-[10px] text-white/85 hover:bg-white/10 hover:text-white ${FOCUS_RING_ON_DARK_CLASS}`}
                  onClick={() => {
                    if (social.name === "Facebook") {
                      gtm.navigationClicked({
                        item: "community_social",
                        location: "footer",
                        destination: social.href,
                        control: "footer_link",
                      });
                    }
                  }}
                >
                  <span className="sr-only">Youdle on {social.name}</span>
                  {Icon ? <Icon className="h-5 w-5" /> : null}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </footer>
  );
}
